// ChatContainer.jsx (fixed version)
import React, { useState, useEffect } from "react";
import ChatWindow from "./chatWindow"; // your full-screen chat UI
import useChatDriver from "./components/chat"; // your hook
import ChatLauncher from "./chatLauncher"; // your mini-window component

// 1) Define your cards once
const cardOptions = [
  {
    key: "findLawyer",
    icon: "👩‍⚖️",
    title: "Find the right lawyer",
    desc: "Get matched with a qualified lawyer — fast.",
  },
  {
    key: "learnIssue",
    icon: "📘",
    title: "Understand my legal issue",
    desc: "Learn how the law applies to you.",
  },
  {
    key: "urgentHelp",
    icon: "🚨",
    title: "My issue is urgent",
    desc: "Prioritize me now.",
  },
  {
    key: "learnRights",
    icon: "💬",
    title: "Know my legal rights",
    desc: "Do I even have a case?",
  },
];

export default function ChatContainer() {
  // UI mode: "fab" (just the bubble), "small" (mini launcher), or "full" (full-screen chat)
  const [mode, setMode] = useState("fab");
  const [selectedCard, setSelectedCard] = useState(cardOptions[0].key);
  const [hasSentFirst, setHasSentFirst] = useState(false);
  const [sentCardIntro, setSentCardIntro] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  // Chat logic: messages, input, sendMessage(), etc.
  const {
    messages,
    input,
    lawyerCards,
    lastIds,
    setInput,
    sendMessage,
    abortChat,
  } = useChatDriver({
    systemPrompt: "Hi, I am Quidbot, how can I help you today?",
    selectedCard: cardOptions.find((c) => c.key === selectedCard),
  });

  // Debug logging for lawyerCards changes
  useEffect(() => {
    console.log("ChatContainer received lawyerCards:", lawyerCards);
  }, [lawyerCards]);

  // Callbacks to switch modes
  const openSmall = () => setMode("small");
  const expandFull = () => setMode("full");
  const closeAll = () => {
    abortChat();
    setMode("fab");
    setHasSentFirst(false);
  };

  // Card selection
  const handleCardSelect = (key) => {
    setSelectedCard(key);
    // cards stay visible until user hits send
  };

  // Sending a message
  // const handleSend = async () => {
  //   if (!hasSentFirst) setHasSentFirst(true);
  //   await sendMessage(input);
  // };

  const handleSend = async () => {
    if (!hasSentFirst) setHasSentFirst(true);

    // prepend the card intro exactly once
    if (!sentCardIntro) {
      // first turn: still pass just the raw user text
      await sendMessage(input);
      setSentCardIntro(true);
      return;
    }

    // normal subsequent sends
    if (input.trim() !== "") {
      await sendMessage(input);
    }
  };
  // Props we share between mini-launcher and full chat
  const sharedProps = {
    options: cardOptions, // your cards
    selectedCard,
    hasSentFirst,
    messages,
    lawyerCards, // Make sure this is passed down
    lastIds,
    showFilters,
    setShowFilters,
    inputValue: input, // matches ChatLauncher & ChatWindow prop
    onCardSelect: handleCardSelect,
    onInputChange: setInput,
    onSend: handleSend, // Fixed to call handleSend directly
    onClose: closeAll,
    onExpand: expandFull,
  };

  return (
    <>
      {mode === "fab" && (
        // show only the bubble icon
        <ChatLauncher mode="fab" onFabClick={openSmall} {...sharedProps} />
      )}

      {mode === "small" && (
        // show mini-window (cards or chat)
        <ChatLauncher mode="small" {...sharedProps} />
      )}

      {mode === "full" && (
        <ChatWindow
          {...sharedProps}
          onMinimize={openSmall} // <-- drop back to mini
        />
      )}
    </>
  );
}
